import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import {
  APPLICANT_CREDIT_CHECK_ACTION_LABEL_KEY,
  QA_NAME_APPLICANT_CREDIT_CHECK_ACTION,
} from '../ApplicantCreditCheckBlock.constants'
import {
  getApplicantCreditCheckActionState,
  getIsApplicantCreditCheckPrimaryAction,
  getIsApplicantCreditCheckUploadAction,
} from '../ApplicantCreditCheckBlock.utils'

import { ApplicantCreditCheckActionUpload } from './ApplicantCreditCheckActionUpload'

function ApplicantCreditCheckAction({
  action,
  applicantData,
  isPreview,
  isSubmitting,
  onClick,
  onFinishUpload,
  onStartUpload,
  onUploadErrors,
}) {
  const { t } = useTranslation()

  const { isHidden, tooltipKey } = getApplicantCreditCheckActionState({
    action,
    applicantData,
    isPreview,
  })

  const isUpload = getIsApplicantCreditCheckUploadAction(action)

  const isDisabled = Boolean(tooltipKey) || isSubmitting

  const ActionButton = getIsApplicantCreditCheckPrimaryAction(action)
    ? Button.Contained
    : Button.Outlined

  function handleClick() {
    onClick(action)
  }

  return isHidden ? null : (
    <ApplicantCreditCheckActionUpload
      isDisabled={isDisabled}
      isUpload={isUpload}
      onFinishUpload={onFinishUpload}
      onStartUpload={onStartUpload}
      onUploadErrors={onUploadErrors}
    >
      <ActionButton
        disabled={isDisabled}
        height={BUTTON_HEIGHT_32}
        isLoading={isSubmitting && isUpload}
        qaName={QA_NAME_APPLICANT_CREDIT_CHECK_ACTION[action]}
        text={t(APPLICANT_CREDIT_CHECK_ACTION_LABEL_KEY[action])}
        tooltip={tooltipKey ? t(tooltipKey) : null}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={isUpload ? null : handleClick}
      />
    </ApplicantCreditCheckActionUpload>
  )
}

export default ApplicantCreditCheckAction
